import styles from './Circle.module.scss';

const defaultRadius = 50;
const defaultStroke = 3.5;

const getStrokeInfo = (percentage: number, radius = defaultRadius) => {
  const circumference = radius * 2 * Math.PI;
  const strokeDasharray = `${circumference} ${circumference}`;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return { strokeDashoffset, strokeDasharray };
};

export const Circle = ({
  strokePercent,
  title,
  subtitle,
  stroke = defaultStroke,
  r = defaultRadius,
}: {
  title?: string;
  subtitle?: string;
  strokePercent: number;
  stroke?: number | string;
  r?: number;
}) => {
  const strokeWidth = parseInt(`${stroke}`, 10);
  const { strokeDasharray, strokeDashoffset } = getStrokeInfo(strokePercent);

  return (
    <div className={styles.circleWrapper}>
      <svg className={styles.svgWrapper} viewBox="0 0 100 100">
        <circle
          className={styles.baseCircle}
          cx={r}
          cy={r}
          fill="transparent"
          r={r - strokeWidth}
          stroke="#E8ECF3"
          strokeLinecap="round"
          strokeWidth={strokeWidth}
        />
        <circle
          className={styles.baseCircle}
          cx={r}
          cy={r}
          fill="transparent"
          r={r - strokeWidth}
          stroke="#fe3b1f"
          strokeDasharray={strokeDasharray}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          strokeWidth={strokeWidth}
        />
      </svg>
      <div className={styles.text}>
        {title}
        <div className={styles.text2}>{subtitle}</div>
      </div>
    </div>
  );
};
